//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue"
export default {
	data() {
		return {
			hotActivityList: [], // 列表
			page: {
				pageSize: 10,
				currentPage: 1,
				count: 0,
				loading: false,
				finished: false
			},
			titList: [
				// 顶部tab
				{
					title: '进行中',
					code: '1'
				},
				{
					title: '即将开始',
					code: '0'
				},
				{
					title: '已结束',
					code: '2'
				}
			],
			activeLine: '1', // tab下划线的位置
			state: '1' // 当前tab选项
		}
	},
	components: {
		uniLoadMore
	},
	onLoad() {
		this.queryData()
	},
	onPullDownRefresh() {
		this.hotActivityList = []
		this.page.currentPage = 1
		this.queryData('refresh')
	},
	onReachBottom() {
		if (this.hotActivityList.length < this.page.count) {
			this.queryData()
		}
	},
	methods: {
		// tab列表选择
		active(val) {
			this.state = val.code
			this.hotActivityList = []
			this.page.currentPage = 1
			this.queryData('', val.code)
			this.activeLine = val.code
		},
		handleClick(item) {
			uni.navigateTo({
				url: `/pages/hotActivity/detail?id=${item.id}`
			})
		},
		// 列表获取
		queryData(status) {
			this.page.loading = true
			this.$ajax({
				method: 'post',
				url: '/weChat/cms/activity/queryPage',
				data: {
					...this.page,
					state: this.state
				}
			}).then(res => {
				this.hotActivityList.push.apply(this.hotActivityList, res.data)
				this.page.count = res.count
				this.page.loading = false
				if (this.hotActivityList.length >= this.page.count) {
					this.page.finished = true
				}
				this.page.currentPage += 1
				if (status === 'refresh') {
					uni.stopPullDownRefresh();
				}
			})
		},
	}
}
